var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 72",
    style: {
      enableBackground: "new 0 0 66 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED756A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.58,2.58h-0.56c-1.37,0-2.49,1.11-2.49,2.49v0.58v9.44v1.88c0,1.1-0.89,1.59-1.98,1.59h-0.05 c-1.1,0-1.98-0.49-1.98-1.59V15.1V5.65V5.07c0-1.37-1.11-2.49-2.49-2.49h-0.56c-1.37,0-2.49,1.11-2.49,2.49v0.58v9.44v1.88 c0,1.1-0.89,1.59-1.98,1.59h-0.05c-1.1,0-1.98-0.49-1.98-1.59V15.1V5.65V5.07c0-1.37-1.11-2.49-2.49-2.49H8.88 c-1.37,0-2.49,1.11-2.49,2.49v21.13c0,0.39,0.1,0.76,0.26,1.09c0.23,0.64,0.59,1.24,1.12,1.73l4.54,4.15l3.64,3.32v4.43V67.4 c0,1.37,1.11,2.49,2.49,2.49h0.56c1.37,0,2.49-1.11,2.49-2.49V40.93V36.5l3.64-3.32l4.54-4.15c0.54-0.49,0.9-1.09,1.12-1.73 c0.16-0.33,0.26-0.7,0.26-1.09V5.07C31.07,3.7,29.95,2.58,28.58,2.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.61,19.72c0-7.33-4.82-17.61-10.76-17.61S38.08,12.39,38.08,19.72c0,6.15,3.39,11.31,7.99,12.82V67.4 c0,1.37,1.11,2.49,2.49,2.49h0.56c1.37,0,2.49-1.11,2.49-2.49V32.54C56.21,31.03,59.61,25.87,59.61,19.72z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon1);
export default __webpack_public_path__ + "static/media/box_icon1.68cc3c336a339f10fd8984817eebbc2c.svg";
export { ForwardRef as ReactComponent };